"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumOnChainQuerier = void 0;
const _1 = require(".");
const assets_1 = require("../assets");
class EthereumOnChainQuerier {
    constructor(provider) {
        this.provider = provider;
    }
    async queryTokensOwnedByAddress(token, address) {
        const erc721 = _1.IERC721__factory.connect(token, this.provider);
        const outboundFilter = erc721.filters.Transfer(address, null, null);
        const inboundFilter = erc721.filters.Transfer(null, address, null);
        const [outbound, inbound] = await Promise.all([
            erc721.queryFilter(outboundFilter),
            erc721.queryFilter(inboundFilter),
        ]);
        const ownershipHistory = [
            ...outbound.map((tx) => ({ ...tx, owned: false })),
            ...inbound.map((tx) => ({ ...tx, owned: true })),
        ];
        ownershipHistory.sort((x, y) => {
            const blockDiff = x.blockNumber - y.blockNumber;
            return blockDiff === 0
                ? x.transactionIndex - y.transactionIndex
                : blockDiff;
        });
        const tokenOwnedMemo = new Map();
        for (const entry of ownershipHistory) {
            tokenOwnedMemo.set(entry.args.tokenId.toBigInt(), entry.owned);
        }
        const ownedTokens = [];
        for (let [token, isOwned] of tokenOwnedMemo.entries()) {
            if (isOwned)
                ownedTokens.push(token);
        }
        return new assets_1.Tokens(ownedTokens);
    }
}
exports.EthereumOnChainQuerier = EthereumOnChainQuerier;
//# sourceMappingURL=ethereumOnChainQuerier.js.map